// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 796 ? "5330eab6" : chunkId) + "." + {"447":"4e0f40f79b23afa5","796":"6fe98c2a04ac2dda","966":"aca70759a2ba8bb7"}[chunkId] + ".js";
};